// extracted by mini-css-extract-plugin
export default {"input-list":"FormAddingCallingList_input-list__DHbod"};